import { BookOpen, Stethoscope, Baby, HeartHandshake, Phone } from "lucide-react";

const sections = [
  {
    icon: Baby,
    title: "Understanding the NICU",
    items: [
      "The NICU (Neonatal Intensive Care Unit) cares for premature and critically ill newborns.",
      "Common milestones: breathing on their own, maintaining temperature, feeding, and steady weight gain.",
      "It's okay to ask the care team to explain equipment, monitors, and every number you see.",
    ],
  },
  {
    icon: Stethoscope,
    title: "Trach (Tracheostomy) Care",
    items: [
      "A trach is a small tube placed in the windpipe to help your child breathe.",
      "Daily care includes suctioning, cleaning the stoma, and changing ties as instructed.",
      "Always keep an emergency 'go bag' with a spare trach, suction, and supplies nearby.",
    ],
  },
  {
    icon: HeartHandshake,
    title: "G-Tube (Feeding Tube) Care",
    items: [
      "A g-tube delivers nutrition directly to the stomach when oral feeding isn't safe or enough.",
      "Keep the site clean and dry; watch for redness, leakage, or granulation tissue.",
      "Flush before and after feeds and meds to prevent clogs.",
    ],
  },
  {
    icon: Phone,
    title: "Support & Emergencies",
    items: [
      "Keep your care team, pediatrician, and equipment supplier numbers easy to reach.",
      "For any breathing emergency, follow your trained emergency plan and call your local emergency number.",
      "You are not alone — lean on this community and your medical team.",
    ],
  },
];

export default function Resources() {
  return (
    <div className="max-w-5xl mx-auto px-5 md:px-8 py-12">
      <div className="flex items-center gap-3 mb-2">
        <BookOpen className="text-[#6B8EAC]" size={30} />
        <h1 className="font-display text-4xl md:text-5xl text-[#1A202C]">Resources</h1>
      </div>
      <p className="text-[#4A5568] mb-8 max-w-2xl">
        Gentle, practical information for families navigating NICU, trach, and g-tube care.
        Always follow your own medical team's guidance first.
      </p>

      <div className="grid md:grid-cols-2 gap-4">
        {sections.map((s) => (
          <div key={s.title} data-testid={`resource-${s.title.toLowerCase().split(" ")[0]}`} className="bg-white border border-[#6A0DAD] rounded-2xl p-7 shadow-sm">
            <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#6B8EAC] text-white mb-4"><s.icon size={22} /></span>
            <h2 className="font-heading text-xl font-semibold text-[#1A202C] mb-3">{s.title}</h2>
            <ul className="space-y-2.5">
              {s.items.map((item) => (
                <li key={item} className="text-[#4A5568] leading-relaxed flex gap-2">
                  <span className="text-[#D4AF37] mt-1.5 shrink-0 w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-6 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-2xl p-6 text-center">
        <p className="text-[#4A5568] leading-relaxed">
          This information is for support only and is not medical advice. Always consult your child's
          healthcare team for decisions about their care.
        </p>
      </div>
    </div>
  );
}
